/** @format */

import { getArticles, getStops, getDestinations, isErrorResponse } from '../../api/api';
import { action, computed, thunk } from 'easy-peasy';
import uuid from 'uuid';

const TravelSearchModel = {
	error: null,
	availableFromStops: [],
	availableToStops: [],
	availableToStopsLoading: false,
	stopIdsToIgnore: [],
	fromStop: null,
	toStop: null,
	departureDate: null,
	items: [],
	totalItemsCount: computed((state) =>
		state.items.reduce((x, y) => {
			return parseInt(x) + parseInt(y.countItems);
		}, 0)
	),
	selectedItems: computed((state) =>
		state.items
			.filter((x) => x.countItems > 0)
			.map((x) => ({ Name: x.article.name, PBE: x.article.pbe, ItemCount: x.countItems }))
	),
	//Thunks
	fetchAvailableArticles: thunk(async (actions) => {
		const task = await getArticles();
		const res = await task;
		if (isErrorResponse(res)) {
			actions.setError(res);
		} else {
			actions.setItems(res);
		}
	}),
	fetchAvailableFromStops: thunk(async (actions) => {
		const task = await getStops();
		const res = await task;
		if (isErrorResponse(res)) {
			actions.setError(res);
		} else {
			actions.setAvailableFromStops(res);
		}
	}),
	fetchAvailableToStops: thunk(async (actions, stop) => {
		const task = await getDestinations(stop);
		const res = await task;
		if (isErrorResponse(res)) {
			actions.setError(res);
		} else {
			actions.setAvailableToStops(res);
		}
	}),
	//Actions
	setStopIdsToIgnore: action((state, stopIdsCsv) => {
		state.stopIdsToIgnore = stopIdsCsv.split(',');
	}),
	setError: action((state, error) => {
		state.error = error;
	}),
	setLoadingOut: action((state, value) => {
		state.loadingOut = value;
	}),
	setLoadingIn: action((state, value) => {
		state.loadingIn = value;
	}),
	setAvailableFromStops: action((state, stops) => {
		state.availableFromStops = stops.filter((x) => {
			return !state.stopIdsToIgnore.includes(x.id);
		});
	}),
	setAvailableToStops: action((state, stops) => {
		state.availableToStops = stops.filter((x) => {
			return !state.stopIdsToIgnore.includes(x.id);
		});
		state.availableToStopsLoading = false;
	}),
	setFromStop: action((state, stopSelect) => {
		state.availableToStopsLoading = true;

		for (var i = 1; i < stopSelect.options.length; i++) {
			if (stopSelect.options[i].selected === true) {
				state.fromStop = { id: stopSelect.options[i].value, name: stopSelect.options[i].text };
				state.resultOut = null;
				state.resultIn = null;
			}
		}
	}),
	setToStop: action((state, stopSelect) => {
		for (var i = 1; i < stopSelect.options.length; i++) {
			if (stopSelect.options[i].selected === true) {
				state.toStop = { id: stopSelect.options[i].value, name: stopSelect.options[i].text };
			}
		}
	}),
	setItems: action((state, articles) => {
		state.items = articles.map((x) => {
			return {
				id: uuid.v4(),
				article: { name: x.name, sort: x.sort, pbe: x.pbe },
				countItems: 0,
			};
		});
	}),
	setDepartureDate: action((state, d) => {
		state.departureDate = d;
	}),
	setItemCount: action((state, item) => {
		state.items.map((x) => {
			if (x.id === item.id) {
				x.countItems = parseInt(item.itemCount);
			}
			return x;
		});
	}),
	validateItemCount: action((state, id) => {
		state.items.map((x) => {
			if (x.id === id) {
				if (!x.countItems) x.countItems = 0;
			}
			return x;
		});
	}),
	selectItem: action((state, id) => {
		state.items.map((x) => {
			if (x.id === id && x.countItems === 0) {
				x.countItems = 1;
			} else {
				x.countItems = 0;
			}

			return x;
		});
	}),
	reset: action((state) => {
		state.error = null;
		state.fromStop = null;
		state.toStop = null;
		state.departureDate = null;
		state.items = [];
	}),
};

export default TravelSearchModel;
